module.exports = __webpack_public_path__ + "img/party-text.21db9fa4.svg";